
export default {
  name: 'VsPaginationNext',
  inject: ['pagination'],
  vessel: {
    button: {
      display: 'flex',
      flexItems: 'center',
      flexJustify: 'center',
      paddingLeft: 'xs',
      fontSize: 'md',
      cursor: 'pointer',
      userSelect: 'none',
      $disabled: {
        pointerEvents: val => val ? 'none' : null,
        color: val => val ? 'grey' : null
      },
      hover: {
        color: 'primary'
      }
    }
  },
  computed: {
    disabled() {
      return this.pagination.disabled || !this.pagination.hasNext
    },
    text() {
      return this.pagination.nextText
    }
  }
}
